export function MenuIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
      <path
        fill="currentColor"
        d="M80 96h352v32H80zm0 144h352v32H80zm0 144h352v32H80z"
      ></path>
    </svg>
  );
}
